function ArrowWithBg({ width, height }) {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 80 80"
  >
    <g data-name="Group 4054" transform="translate(-174 -1896)">
      <circle
        cx="40"
        cy="40"
        r="40"
        fill="#24397a"
        data-name="Ellipse 62"
        transform="translate(174 1896)"
      ></circle>
      <path
        fill="#fff"
        d="M31.975-25.7l-4 25.944a2 2 0 01-1 1.441 2.005 2.005 0 01-.98.256 1.984 1.984 0 01-.768-.154L17.566-1.4l-3.179 4.764A1.24 1.24 0 0113.3 4 1.3 1.3 0 0112 2.7v-6.011a2 2 0 01.421-1.228L26-22 7.644-5.481 1.231-8.156A2.007 2.007 0 010-9.931a1.944 1.944 0 011-1.861l28-15.944a2 2 0 012.125.088 1.994 1.994 0 01.85 1.948z"
        data-name="Path 2252"
        transform="translate(197 1948)"
      ></path>
    </g>
  </svg>
  )
}

export default ArrowWithBg
